export default __webpack_public_path__ + "static/media/04_DAIF_Infra_04_05.d61809c7.mp4";